var __TEMP__ = require('./_assocIndexOf.js');var assocIndexOf = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = listCacheSet;
